import { ClickAwayListener, IconButton, ListItemIcon, MenuItem, MenuList, Paper, Popper, Typography } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useEffect, useState } from "react";
import DeleteAppConfigDialog from "./dialog/delete-app-config-dialog.component";
import UpdateAppConfigDialog from "./dialog/update-app-config-dialog.component";


function ActionsPopperComponent(props){

    const { list, setDeletedList, setUpdatedList } = props

    const [anchorEl, setAnchorEl] = useState(null);
    const [openDeleteAppConfig, setOpenDeleteAppConfig] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenUpdateAppConfig = () => {
        setOpenDialog(true)
    }

    const handleCloseCreateDialog = () => {
        setOpenDialog(false)
    }

    const handleClose = () => {
        setOpenDeleteAppConfig(false)
    }

    const handleOpenDialog = () =>{
        setOpenDeleteAppConfig(true)
    }

    const handleClick = (event) => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    };


    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;



  
    return (
        <div>
            <IconButton sx={{color: 'black'}}>
                <MoreVertIcon aria-describedby={id} style={{cursor: "pointer"}} onClick={handleClick}  />
            </IconButton>
            <Popper id={id} open={open} anchorEl={anchorEl}>
                <Paper style={{borderRadius: 2}}>
                    <ClickAwayListener onClickAway={handleClick}>
                        <MenuList>
                            <MenuItem onClick={handleOpenUpdateAppConfig} style={{color: '#0178f2', fontSize: 13, fonWeight: 500}}>
                                <ListItemIcon style={{padding: 0, minWidth: 30}}>
                                    <IconButton style={{paddingTop: 6, paddingBottom: 6, color: '#0178f2'}}>
                                        <EditIcon style={{width: 16, height: 16}} />
                                    </IconButton>
                                </ListItemIcon>
                                <Typography variant="inherit">Update</Typography>
                            </MenuItem>
                            
                            <MenuItem  onClick={handleOpenDialog} style={{color: 'red', fontSize: 13, fonWeight: 500}} >
                                <ListItemIcon style={{padding: 0, minWidth: 30}}>
                                    <IconButton style={{paddingTop: 6, paddingBottom: 6, color: 'red'}}>
                                        <DeleteIcon style={{width: 16, height: 16}}/>
                                    </IconButton>
                                </ListItemIcon>
                                <Typography variant="inherit">Delete</Typography>
                            </MenuItem>
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>

            {/* DIALOG */}
            <UpdateAppConfigDialog openDialog={openDialog} handleClose={handleCloseCreateDialog} appConfigDetails={list} setUpdatedList={setUpdatedList} />
            <DeleteAppConfigDialog  list={list} openDeleteAppConfig={openDeleteAppConfig}  handleClose={handleClose} setDeletedList={setDeletedList} />

        </div>
    )
}

export default ActionsPopperComponent
